import { isInteger } from "lodash";
import { LogicActionType } from "../../screens/Quiz";

type LogicState = {
    global: any;
    local: any;
    stream: any[];
};

const defaultState = {
    local: {},
    global: {},
};

const defaultLogicState = {
    internal: { ...defaultState },
    external: { ...defaultState },
};

const testCondition = (
    condition: any,
    internalState: any,
    externalState: any,
) => {
    let result = false;
    let isInverseCondition = condition?.isInverseCondition || false;

    switch (condition.type) {
        case "FLAG": {
            const flagValue = internalState?.local[condition.flagKey] || false;
            if (flagValue === condition.flagValue) {
                result = true;
            }
            break;
        }
        case "GLOBAL_FLAG": {
            const globalFlagValue =
                externalState?.global[condition.globalFlagKey] || false;
            const cachedFlagValue =
                internalState?.global[condition.globalFlagKey] || false;
            const computedValue = cachedFlagValue || globalFlagValue;
            if (computedValue === condition.globalFlagValue) {
                result = true;
            }
            break;
        }
        case "TALLY": {
            const tallyValue = isInteger(
                internalState?.local[condition.tallyKey],
            );
            if (tallyValue > condition.tallyValueAbove) {
                result = true;
            }
            break;
        }
        case "GLOBAL_TALLY": {
            const globalTallyValue = isInteger(
                externalState?.global[condition.globalTallyKey],
            )
                ? externalState.global[condition.globalTallyKey]
                : 0;
            const cachedGlobalTallyValue = isInteger(
                internalState?.global[condition.globalTallyKey],
            )
                ? internalState.global[condition.globalTallyKey]
                : 0;
            const computedValue = globalTallyValue + cachedGlobalTallyValue;
            if (computedValue > condition.globalTallyValueAbove) {
                result = true;
            }
            break;
        }
    }
    if (isInverseCondition) {
        return !result;
    } else {
        return result;
    }
};
export const logicStateReducer = (acc, streamAction) => {
    let nextAcc = acc;

    switch (streamAction.type) {
        case LogicActionType.SetFlag: {
            nextAcc = {
                ...acc,
                local: {
                    ...acc.local,
                    [streamAction.key]: streamAction.value,
                },
            };
            break;
        }

        case LogicActionType.SetGlobalFlag: {
            nextAcc = {
                ...acc,
                global: {
                    ...acc.global,
                    [streamAction.key]: streamAction.value,
                },
            };

            break;
        }

        case LogicActionType.IncrementTally: {
            const originalValue = isInteger(acc.local[streamAction.key])
                ? acc.local[streamAction.key]
                : 0;
            const newValue = isInteger(streamAction.value)
                ? originalValue + streamAction.value
                : originalValue;

            nextAcc = {
                ...acc,
                local: {
                    ...acc.local,
                    [streamAction.key]: newValue,
                },
            };
            break;
        }

        case LogicActionType.IncrementGlobalTally: {
            const originalValue = isInteger(acc.global[streamAction.key])
                ? acc.global[streamAction.key]
                : 0;
            const newValue = isInteger(streamAction.value)
                ? originalValue + streamAction.value
                : originalValue;

            nextAcc = {
                ...acc,
                global: {
                    ...acc.global,
                    [streamAction.key]: newValue,
                },
            };
            break;
        }
    }

    return nextAcc;
};

export const isAvailable = (item, logicState = defaultLogicState) => {
    if (!item.conditions || item.conditions.length === 0) {
        return true;
    }
    const { internal: internalState, external: externalState } = logicState;
    const isAvailable = item.conditions.reduce((acc, condition) => {
        if (acc) {
            return acc;
        }
        let result = acc;
        if (condition.conditions?.length) {
            // map result to a list
            const children = condition.conditions.map(condition =>
                testCondition(condition, internalState, externalState),
            );
            // result === true if all children are true
            result = children.filter(child => child === false).length === 0;
        } else {
            result = testCondition(condition, internalState, externalState);
        }
        return result;
    }, false);
    return isAvailable;
};

export function externalStateReducer(logicStates: LogicState[] | null) {
    let _logicStates = logicStates ?? [];
    return _logicStates.reduce(
        (acc, logicState) => {
            const result = logicState.stream.reduce(logicStateReducer, acc);

            return result;
        },
        {
            local: {},
            global: {},
        },
    );
}
